import { Loading } from '@enums/index';

export interface LoadingItem {
  name?: string;
  loading: Loading;
}

